import * as firebase from 'firebase/app';
import 'firebase/auth';

function AuthenticationCtrl($scope, $log, $state, $timeout,
                            sweet,
                            SessionsService,
                            ProgressBarService,
                            UnifiedLoginService
                            ) {
  "ngInject";

  let vm = this;

  vm.onGoogleSignInSuccess = function (authResult) {
    if (!vm.googleSignInButtonClicked) {
      ProgressBarService.start();
    }

    SessionsService.setIsBeamAuth(false);

    let promise = SessionsService.login(authResult);
    return promise.then(vm.loginSuccess, vm.loginFailure);
  };

  vm.onGoogleSignInFailure = function (event, authResult) {
    if (vm.googleSignInButtonClicked) {
      ProgressBarService.complete();
      return sweet.show('Oops...', 'Unable to authenticate to Google.', 'error');
    }
  };

  vm.firebaseSignIn = async function () {
    const provider = new firebase.auth.GoogleAuthProvider();
    provider.addScope('https://www.googleapis.com/auth/userinfo.email');
    provider.addScope('https://www.googleapis.com/auth/userinfo.profile');

    try {
      ProgressBarService.start();

      const user = await firebase.auth().signInWithPopup(provider);
      vm.onGoogleSignInSuccess(user);
    } catch(err) {
      console.error(err);
      vm.onGoogleSignInFailure();
    }
  };

  vm.initializeSignIn = async function () {
    vm.googleSignInButtonClicked = false;

    try {
      // if there is a cookie from beam, attempt to validate and sign automatically
      const { userIdToken } = await UnifiedLoginService.validateSessionCookie();

      if (userIdToken) {
        // capture where the user is coming from, quick fix for now
        SessionsService.setIsBeamAuth(true);

        return SessionsService.login(userIdToken)
          .then(vm.loginSuccess, vm.loginFailure);
      } else {
        // capture where the user is coming from, quick fix for now
        SessionsService.setIsBeamAuth(false);
      }
    } catch(err) {
      console.error('err');
      SessionsService.setIsBeamAuth(false);
    }
  };

  vm.initializeSignOut = async function () {
    await SessionsService.logout();
    
    return $timeout(vm.proceedToSignedOut, 50);
  };

  vm.initializeSignedOut = () => {
    return $timeout(vm.initializeSignIn, 3000);
  }


  vm.loginSuccess = function (haveManagingOrgs) {
    if (haveManagingOrgs) {
      $state.go('main.managing_org_selection');
    } else {
      $state.go('main.noManagingOrgs')
    }
    ProgressBarService.complete();
  };

  vm.loginFailure = function () {
    ProgressBarService.complete();
    return sweet.show('Oops...', 'Unable to authenticate to Google.', 'error');
  };

  vm.proceedToSignedOut = () => {
    $state.go('main.signed_out')
  };

  vm.proceedToSignIn = () => $state.go('main.sign_in');

  vm.onClickGoogleSignIn = function () {
    vm.googleSignInButtonClicked = true;
    return ProgressBarService.start();
  };

  vm.redirectToBeamSignIn = () => {
    const e = location.hostname === 'localhost' ? 'local' : process.env.__environment__;
    let beamUrl = '';

    switch(e) {
      case 'int':
        beamUrl = 'https://beam-int.skykit.com/';
        break;
      case 'qa':
        beamUrl = 'https://beam-int.skykit-qa.skykit.com/';
        break;
      case 'stage':
        beamUrl = 'https://beam-int.skykit-stage.skykit.com/';
        break;
      case 'prod':
        beamUrl = 'https://beam-int.skykit.skykit.com/';
        break;
      case 'local':
        beamUrl = 'https://localhost:7999/';
        break;
    }

    window.location.replace(`${beamUrl}redirect/${window.location.host}`);
  };

  return vm;
}

export {AuthenticationCtrl}
